import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from "@mui/styles";
import { usuariosPath } from "~constants/referenceNames";
import ListadoUsuarios from "./listadoUsuarios/ListadoUsuarios";
import UsuarioEditor from "./usuarioEditor/UsuarioEditor";
import { getUsuarios, getUsuario, setCurrentUsuario } from "./actions";
import { setTake, setPage } from "./Filtros/actions";
import UnexpectedError from "~styled/errorPages/UnexpectedError";
import { selectSearchCriteria } from "./Filtros/actions";
import { useHistory, useLocation } from "react-router-dom";
import {
  getUrlWithParameters,
  updateUrlParameters,
} from "~hooks/urlSearcherManager";
import SectionLayout from "~styled/layouts/sectionLayout/SectionLayout";
import { GetUsuarioResponse, Usuario } from "~api/types";
import { TakeValue } from "./types";

const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
  },
  body: {
    display: "flex",
    flexDirection: "row",
    alignItems: "right",
    width: "100%",
  },
}));

interface SliceUsuarios {
  isLoading: boolean;
  failed: boolean;
  failedUsuarioEditor: boolean;
  page: number;
  take: TakeValue;
  searchCriteria: string;
  getOnlyActivos: boolean;
  currentUsuario: GetUsuarioResponse | null;
}

const useReduxSelector = () =>
  useSelector<any, SliceUsuarios>((state) => ({
    isLoading: state.usuariosReducer.isLoading,
    failed: state.usuariosReducer.failed,

    failedUsuarioEditor: state.usuarioEditorReducer.failed,

    page: state.filtrosUsuariosReducer.page,
    take: state.filtrosUsuariosReducer.take,
    searchCriteria: state.filtrosUsuariosReducer.searchCriteria,
    getOnlyActivos: state.filtrosUsuariosReducer.getOnlyActivos,

    currentUsuario: state.usuariosReducer.currentUsuario,
  }));

const params = [
  { name: "take", nameUrl: "Take", action: setTake },
  {
    name: "searchCriteria",
    nameUrl: "SearchCriteria",
    action: selectSearchCriteria,
  },
];

const ListadoUsuariosContainer: React.FC = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const currentState = useReduxSelector();
  const {
    page,
    take,
    isLoading,
    searchCriteria,
    currentUsuario,
    failed,
    failedUsuarioEditor,
    getOnlyActivos,
  } = currentState;

  const [openEditor, setOpenEditor] = useState(false);

  const handleEdit = (usuario: Usuario) => () => {
    dispatch(getUsuario(usuario.id) as any);
    setOpenEditor(true);
  };

  const handleClose = () => {
    dispatch(setCurrentUsuario(null));
    setOpenEditor(false);
  };

  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    const url = getUrlWithParameters({
      params,
      currentState,
      index: usuariosPath,
    });

    setUrl(url);
    history.replace(url);

    //eslint-disable-next-line
  }, [history, searchCriteria, page, take]);

  useEffect(() => {
    updateUrlParameters({
      params,
      location,
      dispatch,
      setPage,
    });

    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!isLoading && url) {
      dispatch(
        getUsuarios(
          page * Number(take),
          take,
          searchCriteria,
          getOnlyActivos
        ) as any
      );
    }
    //eslint-disable-next-line
  }, [dispatch, url, getOnlyActivos]);

  if (failed || failedUsuarioEditor) return <UnexpectedError />;
  return (
    <SectionLayout title={"Usuarios"}>
      <div className={classes.root}>
        <div className={classes.body}>
          <ListadoUsuarios onEdit={handleEdit} />
          {openEditor && (
            <UsuarioEditor
              isLoading={!currentUsuario}
              usuario={currentUsuario}
              onClose={handleClose}
            />
          )}
        </div>
      </div>
    </SectionLayout>
  );
};

export default ListadoUsuariosContainer;
